module.exports = __webpack_public_path__ + "img/tu05.6fb41ef3.png";